import cookies from "vue-cookies"
const ProjFn = {
    getToken: () => {
        return (cookies as any).get("token")
    },
    setToken: (token) => {
        (cookies as any).set("token", token, 60 * 60 * 24)
    },
    removeToken: () => {
        (cookies as any).remove("token")
    }
}

export default ProjFn;
